import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Whattrip() {
  return (
    <section className="what_trip p-100 text_trip">
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>
              What Did <span>We Do?</span>
            </h2>
            <p>
              We carefully analyzed and documented the issues, and the
              improvements required in iOS, Android, and web applications and
              proposed a comprehensive plan to enhance the current standing.
            </p>
            <div className="what_trip_img">
              <StaticImage
                src="../../../images/case-studies/equi-trip/what_mob_img.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={1105}
                height={650}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Whattrip;
